import { produce } from 'immer'
import * as services from '@/pages/person/appraise/service'

export type CustomEvaluateSaveReq = {
  id: string
  name: string
  group_id: string
  story_ids: string[]
  details: EvaluateDetail
}

export type EvaluateDetail = {
  scheme_id: string
  title: string
  content: string
  weight: number
}

export type CustomEvaluateListReq = {
  group_ids: string[]
  fuzzy: string
  page_num: number
  page_size: number
  totalNum: number
}

export type CustomEvaluateListData = {
  id: string
  group_id: string
  name: string
  stories: string[]
}

const UserModel = {
  namespace: 'appraiseDimensions',

  state: {
    appraiseGroupList: [],
    appraiseList: [],
    searchValue: {
      page_num: 1,
      page_size: 20,
      fuzzy: null,
    },
    loading: false,
    groupId: '',
    totalNum: 0,
  },

  subscriptions: {},
  effects: {
    // 保存自定义评价
    *saveAppraise({ payload }, { put, call, select }) {
      yield put({
        type: 'setState',
        payload: { appraiseList: [] },
      })
      const res = yield call(services.saveAppraise, payload)
      return res
    },
    // 自定义评价列表
    *fetchAppraiseList({ payload }, { put, call, select }) {
      const res = yield call(services.fetchAppraiseList, payload)
      yield put({
        type: 'setState',
        payload: {
          loading: false,
          appraiseList: res?.data?.data || [],
          totalNum: res?.data?.page?.total,
        },
      })
      return res
    },
    // 自定义评价详情
    *fetchAppraiseDetail({ payload }, { put, call, select }) {
      const res = yield call(services.fetchAppraiseDetail, payload)
      return res
    },
    // 自定义评价批量分组
    *appraisesMove({ payload }, { put, call, select }) {
      const res = yield call(services.appraisesMove, payload)
      return res
    },
    // 自定义评价批量删除
    *appraisesDel({ payload }, { put, call, select }) {
      const res = yield call(services.appraisesDel, payload)
      return res
    },
    // 自定义评价分组列表
    *fetchAppraiseGroupsList({ payload }, { put, call, select }) {
      const res = yield call(services.fetchAppraiseGroupsList, payload)
      const list = res.data.group_list
      const specialList = list.filter((item) => item.name === '未分组' || item.name === '预设方案')
      const remainingList = list.filter(
        (item) => item.name !== '未分组' && item.name !== '预设方案'
      )

      const newList = specialList.concat(remainingList)
      yield put({
        type: 'setState',
        payload: {
          appraiseGroupList: newList,
          loading: false,
        },
      })
      return newList
    },
    // 自定义评价分组保存
    *appraiseGroupSave({ payload }, { put, call, select }) {
      const res = yield call(services.appraiseGroupSave, payload)
      return res
    },
    // 自定义评价分组删除
    *appraiseGroupsDel({ payload }, { put, call, select }) {
      const res = yield call(services.appraiseGroupsDel, payload)
      return res
    },
    // 自定义评价分组清空
    *emptyAppraiseGroups({ payload }, { put, call, select }) {
      const res = yield call(services.emptyAppraiseGroups, payload)
      yield put({ type: 'fetchAppraiseGroupsList' })
      return res
    },
  },
  reducers: {
    setState(state = {}, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
    cleared: produce((state) => {
      state.appraiseGroupList = []
      state.appraiseList = []
      state.searchValue = {
        page_num: 1,
        page_size: 20,
        fuzzy: null,
      }
      state.loading = false
      state.groupId = ''
      state.totalNum = 0
    }),
    resetSearchVal: produce((state) => {
      state.searchValue = {
        page_num: 1,
        page_size: 20,
        fuzzy: null,
      }
    }),
  },
}

export default UserModel
